export const getDocumentIcon = (type: string) => {
    if (type === "ContentMap") {
        return "fa-book default-grey-icon-color";
    } else if (type === "Topic") {
        return "fa-file-lines default-grey-icon-color";
    }
    return "";
};
